<template>
    <div class="where-we-do-it">
        <b-tabs content-class="mt-5" justified v-model="tabIndex">
            <b-tab active @click="activeTab = 1">
                <template #title>
                    <div class="gotham-book text-left">
                        01
                        <br>
                        <span class="reveal-step">
                            SOCIAL MEDIA
                        </span>
                    </div>
                    <div class="list-bullet"></div>
                </template>
                <b-row>
                    <b-col md="4" class="d-md-flex">
                        <div class="decorative-line-across"></div>
                        <p class="gotham-book px-4">
                            <span class="gotham-bold">Social Media</span> 
                            <br>
                            Socialists. Wait, That's Not The Right Word.
                        </p>
                    </b-col>
                    <b-col md="8" class="d-md-flex">
                        <p class="gotham-book px-4 fade-up">
                            The real socialites of the office, the Social Media Department is your daily line of communication to your target audience. They're a close-knit team with a bubbly personality that always gets the conversation started. They know their memes, know what's trending, and most importantly, know how to keep brands relevant in this fast-paced digital world. Ensuring our clients are top-of-mind whenever their audience needs them. It's all of this and so much more that makes them #unique.
                            <br>
                            <br>
                            When they're not on the clock, they enjoy long walks on the beach, reading in bed, the smell of freshly cut grass, and cheesy dating profile bios.
                        </p>
                        <div class="decorative-line-across"></div>
                    </b-col>
                </b-row>
            </b-tab>
            <b-tab active>
                <template #title>
                    <div class="gotham-book text-left">
                        02
                        <br>
                        <span class="reveal-step">
                            CREATIVE
                        </span>
                    </div>
                    <div class="list-bullet"></div>
                </template>
                <b-row>
                    <b-col md="4" class="d-md-flex">
                        <div class="decorative-line-across"></div>
                        <p class="gotham-book px-4">
                            <span class="gotham-bold">Creative</span>
                        </p>
                    </b-col>
                    <b-col md="8" class="d-md-flex">
                        <p class="gotham-book px-4 fade-up">
                            What you see is what you get, and only the best will do when it comes to our Creative Department. Comprised of supremely talented designers, artists, animators, and production specialists, this full-service team is the mitochondira of our agency — that is, the powerhouse of our operation. With decades of experience individually and nearly a century when combined, they know how to bring brand visions to life better than anyone. 
                            <br>
                            <br>
                            Driven by inspiration and guided by strategy, they each bring a distinct sense of style and taste to everything they touch. 
                        </p>
                        <div class="decorative-line-across"></div>
                    </b-col>
                </b-row>
            </b-tab>
            <b-tab active>
                <template #title>
                    <div class="gotham-book text-left">
                        03
                        <br>
                        <span class="reveal-step">
                            ACCOUNT EXECUTIVES
                        </span>
                    </div>
                    <div class="list-bullet"></div>
                </template>
                <b-row>
                    <b-col md="4" class="d-md-flex">
                        <div class="decorative-line-across"></div>
                        <p class="gotham-book px-4">
                            <span class="gotham-bold">Account Executives</span>
                        </p>
                    </b-col>
                    <b-col md="8" class="d-md-flex">
                        <p class="gotham-book px-4 fade-up">
                            All the world's a stage, and our phenomenal Account Executives are the star actors. With the utmost dedication to their craft, this talented team works day and night to ensure every aspect of your campaign is running smoothly. They've got the rare gift of taking care of everything you need before you even realize you need it. Their proactive approach to every marketing deliverable, their care for the relationships with clients, and their genuine interest in the success and wellbeing of your campaign make them much more than mere colleagues. 
                            <br>
                            <br>
                            They're friends you can depend on. Always.
                        </p>
                        <div class="decorative-line-across"></div>
                    </b-col>
                </b-row>
            </b-tab>
            <b-tab active>
                <template #title>
                    <div class="gotham-book text-left">
                        04
                        <br>
                        <span class="reveal-step">
                            WEB
                        </span>
                    </div>
                    <div class="list-bullet"></div>
                </template>
                <b-row>
                    <b-col md="4" class="d-md-flex">
                        <div class="decorative-line-across"></div>
                        <p class="gotham-book px-4">
                            <span class="gotham-bold">Web</span>
                        </p>
                    </b-col>
                    <b-col md="8" class="d-md-flex">
                        <p class="gotham-book px-4 fade-up">
                            We call them our Web Wizards for a reason. They're magical. Though they may be a bit on the quieter side, they've got more power in their fingers than Dumbledore. Together in collaboration with the Creative Department, Copy team, and our Account Executives, they build the virtual landscape that brings your brand to life. From the genesis of creation to website hosting, maintenance, analytics, and so much more than us muggles could ever understand, they are the key to digital success.
                            <br>
                            <br>
                            Fun Fact:
                            <br>
                            One Web Wizard recently unplugged themselves from the Matrix. If you experience deja vu, they're probably fiddling with something in the real world.
                        </p>
                        <div class="decorative-line-across"></div>
                    </b-col>
                </b-row>
            </b-tab>
            <b-tab active>
                <template #title>
                    <div class="gotham-book text-left">
                        05
                        <br>
                        <span class="reveal-step">
                            COPY TEAM
                        </span>
                    </div>
                    <div class="list-bullet"></div>
                </template>
                <b-row>
                    <b-col md="4" class="d-md-flex">
                        <div class="decorative-line-across"></div>
                        <p class="gotham-book px-4">
                            <span class="gotham-bold">Copy Team</span>
                        </p>
                    </b-col>
                    <b-col md="8" class="d-md-flex">
                        <p class="gotham-book px-4 fade-up">
                            The Copy team is the best part of Guidelines. There might be some bias here as we're the ones writing these little blurbs, but hey, we're entitled to our opinions too. The Starsky & Hutch of 1063, we serve and protect the laws of grammar and style while monitoring every word that comes out of this place. Armed with creativity, wit, and an arsenal of artistry to back us up, there's nothing we can't handle. We've seen and done it all in our 30+ years walking the beat — from creating brand identities to international marketing campaigns, and everything in between. 
                            <br>
                            <br>
                            For anything that needs words, you can bet your donkey we'll be there.
                        </p>
                        <div class="decorative-line-across"></div>
                    </b-col>
                </b-row>
            </b-tab>
            <b-tab active>
                <template #title>
                    <div class="gotham-book text-left">
                        06
                        <br>
                        <span class="reveal-step">
                            INTERIOR DESIGN
                        </span>
                    </div>
                    <div class="list-bullet"></div>
                </template>
                <b-row>
                    <b-col md="4" class="d-md-flex">
                        <div class="decorative-line-across"></div>
                        <p class="gotham-book px-4">
                            <span class="gotham-bold">Interior Design</span>
                        </p>
                    </b-col>
                    <b-col md="8" class="d-md-flex">
                        <p class="gotham-book px-4 fade-up">
                            At 1063, our Interior Design team makes spaces look good. We mean really, really good. Like award-winning good. If you've ever heard the expression "looks like a million bucks", their work is what started it. Gifted with impeccable taste and a spidey-sense of style, Interior Design elevates brands by creating visceral customer experiences from the ground up. Acclaimed sales spaces, distinctive presentation centres, and beautifully articulated model homes are but a few of the fantastical things they can design in their sleep. 
                            <br>
                            <br>
                            Looking is free, but touching is gonna cost you. 
                        </p>
                        <div class="decorative-line-across"></div>
                    </b-col>
                </b-row>
            </b-tab>
            <b-tab active>
                <template #title>
                    <div class="gotham-book text-left">
                        07
                        <br>
                        <span class="reveal-step">
                            PRODUCTION
                        </span>
                    </div>
                    <div class="list-bullet"></div>
                </template>
                <b-row>
                    <b-col md="4" class="d-md-flex">
                        <div class="decorative-line-across"></div>
                        <p class="gotham-book px-4">
                            <span class="gotham-bold">Production, Fabrication & Installation</span> 
                        </p>
                    </b-col>
                    <b-col md="8" class="d-md-flex">
                        <p class="gotham-book px-4 fade-up">
                            "Strong like bull" is how we'd describe our incredibly hardworking Production, Installation and Fabrication team. They're the ones who bring the vision of your space to life. Working in tandem with our Interior Designers and Account Executives, they move the plan from page to place with the utmost perfection. No angle is a degree off, no carpentry is a quarter-inch too long or short, and no display is a millimetre too high or too low. They take great pride in the work they do, with a devout commitment of giving their best to you.
                            <br>
                            <br>
                            You'd be surprised what a carpenter can do with a beard and long hair. One is even famous for turning water into wine.
                        </p>
                        <div class="decorative-line-across"></div>
                    </b-col>
                </b-row>
            </b-tab>
            <b-tab active>
                <template #title>
                    <div class="gotham-book text-left">
                        08
                        <br>
                        <span class="reveal-step">
                            RENDERINGS
                        </span>
                    </div>
                    <div class="list-bullet"></div>
                </template>
                <b-row>
                    <b-col md="4" class="d-md-flex">
                        <div class="decorative-line-across"></div>
                        <p class="gotham-book px-4">
                            <span class="gotham-bold">Renderings</span> 
                        </p>
                    </b-col>
                    <b-col md="8" class="d-md-flex">
                        <p class="gotham-book px-4 fade-up">
                            If police sketch artists could be more accurate, they'd be almost as good as our Rendering Team. Through top-notch interior design, creative visualization, and close collaboration with architects and clients, our coordinators play an important role in bringing concepts to life. They curate their services on a project-by-project basis to meet your desired timeline, budget, stage of development, and overall vision. In short, they turn the phrase "artist's concept" into a clairvoyant depiction of the future.
                            <br>
                            <br>
                            Speaking of, they do tarot card, palm, and horoscope readings too. Better still, they don't share their offices with a massage parlour.
                        </p>
                        <div class="decorative-line-across"></div>
                    </b-col>
                </b-row>
            </b-tab>
        </b-tabs>
    </div>
</template>

<script>
import gsap from 'gsap';

export default {
    data() {
        return {
            activeTab: 2,
            tabIndex: 1,
            tabAnimation: null
        }
    },
    mounted() {
        this.tabAnimation = gsap;
    },
    watch: {
        tabIndex(newTab, oldTab) {
            if (newTab !== oldTab) {
                this.tabAnimation.from('.fade-up', {
                    opacity: 0,
                    y: 100,
                    duration: 0.3,
                    ease: 'Power4.inOut'
                })
            }
        }
    }
}
</script>

<style lang="scss">
.where-we-do-it {
    height: 380px;

    @media screen and (max-width: 991px) {
        height: 560px;
    }

    @media screen and (max-width: 567px) {
        height: 700px;
    }

    @media screen and (max-width: 400px) {
        height: 780px;
    }

    .decorative-line-across {
        width: 100%;
        max-width: 40px;
        background: #000;
        height: 1px;
        display: inline-block;
        margin-top: 4px;
    }

    .tabs {

        .nav-tabs {
            border: 0;

            li.nav-item {
                margin: 0 2px;

                .nav-link {
                    border: 0;
                    border-top: 1px solid #000;
                    border-radius: unset;
                    color: #000;
                    padding: 0.5rem 0;
                    font-size: 0.85rem;
                }

                .reveal-step {
                    display: none;
                }

                .nav-link {
                    // opacity: 0 !important;
                    // transform: translateY(60px) !important;
                    // transition: 0.3s ease-in-out !important;
                }

                .nav-link.active {
                    border-top: 4px solid #000;
                    background: transparent;
                    

                    .reveal-step {
                        display: inline-block;
                    }
                }
            }
        }
    }
}
</style>